var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewBy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eye_solid_primary") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02_StockAwards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MA_01",
    transform: "translate(-209.000000, -269.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Title",
    transform: "translate(15.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(183.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Summary/Grey",
    transform: "translate(11.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#BABABA",
    strokeWidth: 1,
    cx: 22,
    cy: 23,
    r: 21.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "eye_solid_primary",
    transform: "translate(11.000000, 15.520000)",
    fill: "#00B550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 11.0288949,
    cy: 7.40407609,
    rx: 1.64402174,
    ry: 2.19202899
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0288949,0.82798913 C6.34293478,0.82798913 2.25978261,4.2625 0.06875,7.40407609 C2.25978261,10.5456522 6.34293478,13.980163 11.0288949,13.980163 C15.7148551,13.980163 19.7980072,10.5456522 21.9890399,7.40407609 C19.7970109,4.26150362 15.7148551,0.82798913 11.0288949,0.82798913 L11.0288949,0.82798913 Z M11.0288949,12.3361413 C8.60769928,12.3361413 6.64483696,10.1281703 6.64483696,7.40407609 C6.64483696,4.67998188 8.60769928,2.47201087 11.0288949,2.47201087 C13.4500906,2.47201087 15.4129529,4.67998188 15.4129529,7.40407609 C15.4129529,10.1281703 13.4500906,12.3361413 11.0288949,12.3361413 L11.0288949,12.3361413 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBy);
export default __webpack_public_path__ + "static/media/view-by.7dc9b8a7f438bf4b1cc0a34fa5013bb5.svg";
export { ForwardRef as ReactComponent };